export default "__VITE_ASSET__iH6Arsl0__ 720w";